export const UNITS = {
    K: 'k',
    M: 'M',
    G: 'G',
    T: 'T',
};
